import { BRIDGE_HANDLER } from '@/constants/bridgeHandler'
import { execute } from '@tutorabc/webview-jsbridge'

export const openFullPagePdf = (url: string) => {
  return execute({
    handlerName: BRIDGE_HANDLER.OPEN_PDF,
    data: {
      url,
    },
  })
}
